const {$, $$} = window

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE11() {
  var ua = window.navigator.userAgent

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  // other browser
  return false
}

// IE11 fires a 'change' event instead of an 'input' event
const inputEventName = detectIE11() ? 'change' : 'input'

class DonationRangeSlider {
  constructor(el) {
    this.el = el
    this.rangeInput = $('input[type="range"]', this.el)
    this.valueDisplay = $('[data-value-display]', this.el)

    this.amountField = $('[data-amount-field]', this.el)
    this.goodieField = $('[data-goodie-field]', this.el)

    this.goodies = {}
    this.thresholds = []
    this.activeGoodie = null

    /*
     *  Create an object that contains the element and the according threshold value
     *  and an array with just the thresholds.
     */
    $$('[data-goodie]', this.el).forEach(goodie => {
      let threshold = parseInt(goodie.dataset.goodie)
      this.goodies[threshold] = goodie
      this.thresholds.push(threshold)
    })

    /* reverse the thresholds. this it makes it possible to find the */
    /* last goodie that matches the current slider value */
    this.thresholds = this.thresholds.reverse()
    this.showValue(this.rangeInput.value)
    this.showGoodie(this.rangeInput.value)
    this.addListeners()
  }

  addListeners() {
    this.rangeInput.addEventListener(inputEventName, e => {
      this.showValue(e.target.value)
      this.showGoodie(e.target.value)
    })

    $.delegate(this.el, 'click', '[data-goodie]', e => {
      e.preventDefault()
      this.el.submit()
    })
  }

  /* return the actual value using expo */
  getRealValue(sliderValue) {
    let value = Math.pow(60, sliderValue)

    // Change steps here
    if (value < 100) {
      value = Math.floor(value / 20) * 20
    } else if (value < 250) {
      value = Math.floor(value / 20) * 20
    } else if (value < 500) {
      value = Math.floor(value / 20) * 20
    } else if (value < 1000) {
      value = Math.floor(value / 20) * 20
    } else if (value < 3500) {
      value = Math.floor(value / 100) * 100
    }

    return value
  }

  showValue(sliderValue) {
    let value = this.getRealValue(sliderValue)
    this.valueDisplay.innerText = value
    this.amountField.value = value
  }

  showGoodie(value) {
    let realValue = this.getRealValue(value)
    let goodie = this.getGoodie(realValue)

    if (this.activeGoodie === null) {
      goodie.classList.add('active')
      this.activeGoodie = goodie
    } else if (goodie !== this.activeGoodie) {
      this.activeGoodie.classList.remove('active')
      goodie.classList.add('active')
      this.activeGoodie = goodie
    }

    this.goodieField.value = this.activeGoodie
      ? this.activeGoodie.innerText
      : ''
  }

  /*
   * Get the last goodie with a threshold that is equal or lower than the current slider value.
   */
  getGoodie(value) {
    /* the thresholds array is reversed: starting with highest one. */
    let currentThreshold = this.thresholds.find(threshold => threshold <= value)
    return this.goodies[currentThreshold]
  }
}

export default DonationRangeSlider
